<style scoped>

</style>

<template>
    <div class="b-faq__list">
        <div class="b-faq__list-inner">
            <slot />
        </div>
    </div>
</template>

<script>
export default {
    mounted() {
        const that = this
        that.$children.forEach((item) => {
            item.$on('show', function () {
                that.$children.forEach((closingItem) => {
                    if (closingItem != item) {
                        closingItem.hide()
                    }
                })
            })
        })
    }
}
</script>
